module.exports = {
	"id": "DM",
	"name": "Dominica",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.036894,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.030745,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.129129,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.018447,
			"28": 0.024596,
			"29": null,
			"30": 0.018447,
			"31": 0.06149,
			"32": 0.461175,
			"33": 0.012298,
			"34": 0.086086,
			"35": null,
			"36": 0.055341,
			"37": null,
			"38": 0.006149,
			"39": 0.036894,
			"40": 0.024596,
			"41": 0.030745,
			"42": 0.06149,
			"43": 0.209066,
			"44": 0.012298,
			"45": 0.657943,
			"46": 0.006149,
			"47": 0.030745,
			"48": 0.079937,
			"49": 0.92235,
			"50": 0.135278,
			"51": 0.295152,
			"52": 0.541112,
			"53": 29.293836,
			"54": 6.880731,
			"55": 0.221364,
			"56": 0.049192,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.012298,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": 0.018447,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.012298,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.006149,
			"34": null,
			"35": null,
			"36": 0.012298,
			"37": 0.018447,
			"38": null,
			"39": null,
			"40": null,
			"41": 0.043043,
			"42": 0.024596,
			"43": 0.030745,
			"44": 0.012298,
			"45": 0.036894,
			"46": 0.024596,
			"47": 0.282854,
			"48": 0.276705,
			"49": 5.171309,
			"50": 0.215215,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": null
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.006149,
			"28": null,
			"29": 0.055341,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.012298,
			"34": null,
			"35": null,
			"36": 0.129129,
			"37": 0.159874,
			"38": null,
			"39": 0.024596,
			"40": 0.590304,
			"41": 0.098384,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.006149,
			"12.1": 0.024596
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.006149,
			"6": null,
			"7": 0.012298,
			"8": 0.233662,
			"9": 0.202917,
			"10": 1.199055,
			"3.1": null,
			"3.2": null,
			"5.1": 0.006149,
			"6.1": 0.030745,
			"7.1": 0.036894,
			"9.1": 0.903903
		},
		"ios_saf": {
			"8": 0,
			"10": 2.87661036636,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0775213207744,
			"8.1-8.4": 0.143217355329,
			"9.0-9.2": 0.0683238759367,
			"9.3": 1.0423770816
		},
		"android": {
			"3": 0,
			"4": 0.153343410853,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0191679263566,
			"4.1": 0.553131589147,
			"4.2-4.3": 1.38282897287,
			"4.4": 3.17092267442,
			"4.4.3-4.4.4": 3.19830542636
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.112645317073,
			"9": 0.131419536585,
			"10": 0.093871097561,
			"11": 2.48445504878,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0284091617041,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000789143380669
		},
		"edge": {
			"12": 0.233662,
			"13": 0.79937,
			"14": 1.813955
		},
		"ie_mob": {
			"10": 0.137407042254,
			"11": 0.559442957746
		},
		"bb": {
			"7": 0.144375,
			"10": null
		},
		"samsung": {
			"0": 2.99915
		},
		"and_uc": {
			"0": 0.69685
		},
		"op_mini": {
			"0": 0.382751694915
		},
		"and_chr": {
			"0": 24.809488
		},
		"and_ff": {
			"0": null
		}
	},
	"total": 98.48025
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/DM.json
 ** module id = 509
 ** module chunks = 0
 **/